export const SYSTEM_DEFAULT_PAGE = ""
export const SYSTEM_PAGES = {
  "": "Overview",
  alerts: "Alerts",
  monitoring: "Monitoring",
  forecasting: "Forecasting",
  reporting: "Reporting",
  download: "Download",
  settings: "Settings",
}

export const pages = (
  location: string,
  system: boolean,
): { section: string; name: string; pages: Record<string, string>; defaultPage: string } => {
  const page = location.split("/").pop()

  let sectionPages: Record<string, string> = {}
  let defaultPage = ""
  if (system) {
    sectionPages = SYSTEM_PAGES
    defaultPage = SYSTEM_DEFAULT_PAGE
  }

  let section = page ?? defaultPage
  let name = sectionPages[section]
  if (!name) {
    section = defaultPage
    name = sectionPages[defaultPage]
  }

  return { section, name, pages: sectionPages, defaultPage }
}
